module.exports = __webpack_public_path__ + "img/squint.be160c8f.gif";